import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { COUNTRIES } from '../data/countries';
import { FaTimes } from 'react-icons/fa';

export default function CountrySelectModal({ open, onClose, onSelect, currentCountry }) {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  // Aramaya göre filtrelenmiş ülkeler
  const filtered = useMemo(() => {
    if (!search.trim()) return COUNTRIES;
    return COUNTRIES.filter(c => {
      const countryName = t(`country.${c.code}`, c.name); // Çeviri yoksa orijinal adı kullan
      return countryName.toLowerCase().includes(search.toLowerCase()) ||
             c.code.toLowerCase().includes(search.toLowerCase());
    });
  }, [search, t]);

  // 3 sütuna böl
  const groupedCountries = useMemo(() => {
    return filtered.reduce((acc, country) => {
      const region = country.region || 'Diğer';
      if (!acc[region]) {
        acc[region] = [];
      }
      acc[region].push(country);
      return acc;
    }, {});
  }, [filtered]);

  const regionOrder = ['Avrupa', 'Amerika', 'Asya', 'Afrika', 'Okyanusya', 'Diğer'];

  const orderedRegions = useMemo(() => {
    return regionOrder.filter(region => groupedCountries[region] && groupedCountries[region].length > 0);
  }, [groupedCountries]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-[95vw] max-w-2xl border border-blue-100 flex flex-col gap-4 animate-fade-in" style={{maxHeight: '85vh'}}>
        <div className="flex justify-between items-center mb-2">
          <div className="text-xl font-bold text-blue-900">{t('Ülke Seçimi')}</div>
          <button onClick={onClose} className="text-blue-700 hover:text-blue-900 text-2xl font-bold px-2">&times;</button>
        </div>
        <input
          className="w-full px-4 py-2 mb-3 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-200 outline-none text-blue-900 bg-blue-50"
          placeholder={t('Ülke adı veya kodu ara...')}
          value={search}
          onChange={e => setSearch(e.target.value)}
          autoFocus
        />
        <div className="flex-1 overflow-y-auto pr-2">
          {orderedRegions.map(region => (
            <div key={region} className="mb-4">
              <h3 className="font-bold text-lg text-blue-800 my-2 sticky top-0 bg-white py-1 border-b-2 border-blue-200">{t(`region.${region}`, region)}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1">
                {groupedCountries[region].map(c => (
                  <button
                    key={c.code}
                    onClick={() => { onSelect(c.code); onClose(); }}
                    className={`text-left px-3 py-2 rounded-lg border border-transparent hover:bg-blue-100 transition text-blue-900 ${currentCountry === c.code ? 'bg-blue-100 font-bold border-blue-300' : ''}`}
                  >
                    {t(`country.${c.code}`, c.name)} <span className="text-xs text-blue-400">({c.code})</span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
